import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "calendar",
  "use": "calendar-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 18\" id=\"calendar\"><path fill-rule=\"evenodd\" d=\"M16 18H2a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h2v2H2v12h14V4h-2V2h2a2 2 0 0 1 2 2v12c0 1.105-1 2-2 2M12 6a1 1 0 0 1-1-1V1a1 1 0 0 1 2 0v4a1 1 0 0 1-1 1m-1 6h2a1 1 0 0 1 0 2h-2a1 1 0 0 1 0-2m2-2h-2a1 1 0 1 1 0-2h2a1 1 0 1 1 0 2M8 2h2v2H8zM5 12h2a1 1 0 0 1 0 2H5a1 1 0 0 1 0-2m2-2H5a1 1 0 0 1 0-2h2a1 1 0 0 1 0 2M6 6a1 1 0 0 1-1-1V1a1 1 0 0 1 2 0v4a1 1 0 0 1-1 1\" clip-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol